// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";

function Loader(props) {
  var __showText = props.showText;
  var __branding = props.branding;
  var branding = __branding !== undefined ? __branding : "auto";
  var showText = __showText !== undefined ? __showText : true;
  var arr = [
    "orchestratorx-triangle",
    "orchestratorx-square",
    "orchestratorx-circle"
  ];
  return React.createElement("div", {
              className: "flex flex-col gap-10 justify-center items-center"
            }, React.createElement("div", {
                  className: "flex flex-row gap-10"
                }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                      condition: branding === "auto",
                      children: arr.map(function (item, i) {
                            return JsxPPXReactSupportU.createElementWithKey(i.toString(), Icon$OrcaPaymentPage.make, {
                                        name: item,
                                        size: 52,
                                        style: {
                                          animation: "slowShow 1.5s ease-in-out infinite",
                                          animationDelay: Math.imul(i + 1 | 0, 180).toString() + "ms"
                                        }
                                      });
                          })
                    }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                      condition: branding === "never",
                      children: React.createElement("div", {
                            className: "inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-[#0069FD] border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
                            role: "status"
                          }, React.createElement("span", {
                                className: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
                              }, "Loading..."))
                    })), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: showText,
                  children: React.createElement("div", {
                        className: "flex flex-col gap-5"
                      }, React.createElement("div", {
                            className: "font-semibold text-sm text-gray-200 self-center "
                          }, "We are processing your payment..."), React.createElement("div", {
                            className: "font-medium text-xs text-gray-400 self-center text-center w-3/4 "
                          }, "You have been redirected to new tab to complete your payments. Status will be updated automatically"))
                }));
}

var make = Loader;

export {
  make ,
}
/* react Not a pure module */
